
    import '/vercel/path0/docs/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/index.md?type=demo')
};